import { DatePicker } from "antd";
import { RangePickerProps as DefaultRangePickerProps } from "antd/lib/date-picker";
import { FC } from "react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";

const { RangePicker: DefaultRangePicker } = DatePicker;

export type RangePickerValue = dayjs.Dayjs;
export type RangePickerValues = [RangePickerValue, RangePickerValue];

export type RangePickerProps = Omit<DefaultRangePickerProps, "onChange"> & {
  label?: string;
  showTime?: boolean;
  onChange: (values: RangePickerValues) => void;
};

const RangePicker: FC<RangePickerProps> = ({
  label = "Date Interval",
  format = "MM-DD-YYYY",
  showTime,
  onChange,
  style,
  ...rest
}) => {

  return (
    <div className="input-component">
      {!!label && <div className="input-component__label">{label}</div>}
      <div className="input-component__input">
        <DefaultRangePicker
          {...rest}
          style={{cursor: "default"}}
          format={format}
          showTime={showTime}
          onChange={(values) => {
          onChange(values as RangePickerValues);
          console.log(JSON.stringify(values));
          }}
        />
      </div>
    </div>
  );
};

export default RangePicker;
